import { render, staticRenderFns } from "./Privacypolicy.vue?vue&type=template&id=12c95f0f&"
import script from "./Privacypolicy.vue?vue&type=script&lang=js&"
export * from "./Privacypolicy.vue?vue&type=script&lang=js&"
import style0 from "./Privacypolicy.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fstatic-pages&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports